import classNames from "classnames";
import Cost from "shared/components/Cost";
import Input from "shared/components/Input";
import { CURRENCY_SYMBOL } from "utils/constants";

const InsurancePlan = ({
  logo,
  name,
  description,
  cost,
  currency = "DEFAULT",
  translation,
  checked,
  onCheck,
  checkDisabled,
  disabled,
  baseName,
  baseCost,
  complementName,
  complementCost,
}) => {
  const totalCost = (cost || 0).toFixed(2);

  return (
    <div className="insurance-card-container">
      <div
        className={classNames("insurance-card", {
          "insurance-card--disabled": disabled || checkDisabled,
        })}
      >
        <div className="insurance-card__checkbox">
          <Input
            type="checkbox"
            onChange={(e) => onCheck(e.target.checked)}
            checked={checked}
            disabled={(!checked && checkDisabled) || disabled}
          />
        </div>
        {logo && (
          <div className="insurance-card__image">
            <img src={logo} alt="logo" />
          </div>
        )}
        <div className="insurance-card__item">
          <div className="insurance-card__item--name">{name}</div>
          <span className="insurance-card__item--description">
            {description}
          </span>
        </div>
        <div className="insurance-card__item">
          <div>
            <Cost
              cost={totalCost || "-"}
              currency={currency}
              period={`/ ${translation.PER_MONTH}`}
            />
          </div>
          <span className="insurance-card__item--total">
            {`${(+totalCost * 12).toFixed(0)} ${CURRENCY_SYMBOL[currency]} / ${
              translation.PER_YEAR
            } `}
            <span>{translation.ALL_COST}</span>
          </span>
        </div>
      </div>
      {complementName && (
        <div
          className={classNames("insurance-card", {
            "insurance-card--disabled": disabled || checkDisabled,
          })}
        >
          <div className="insurance-card__checkbox"></div>
          <div className="insurance-card__image"></div>
          <div className="insurance-card__item">
            <div className="insurance-card__item--included">
              {translation.INCLUDED}
            </div>
            <div className="insurance-card__item--upsells">{baseName}</div>
            <div className="insurance-card__item--upsells">
              {complementName}
            </div>
          </div>
          <div className="insurance-card__item justify--end">
            <Cost cost={baseCost || "-"} currency={currency} size="small" />
            <Cost
              cost={complementCost || "-"}
              currency={currency}
              size="small"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default InsurancePlan;
